import type React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { TemplateProfileImage } from '@xing-com/crate-lebenslauf-components';
import {
  type HeaderFontSize,
  getTemplateHeaderFontSize,
} from '@xing-com/crate-lebenslauf-helpers';
import { useReadVitaReactiveVariable } from '@xing-com/crate-lebenslauf-hooks';

const Container = styled.div`
  display: flex;
`;
const Name = styled.div<{ $hasImage?: boolean }>`
  width: 100%;
  position: absolute;
  top: 25px;
  left: ${({ $hasImage }) => ($hasImage ? '170px' : '41px')};
  flex: 1;
`;
const NameField = styled.div<HeaderFontSize>`
  font-size: ${(props) => props.$fontSize}px;
  line-height: ${(props) => props.$fontSize + 14}px;
  font-family: 'Open Sans';
  font-weight: 700;
  color: var(--mainColor);
`;
const Tag = styled.div`
  position: absolute;
  right: 0;
  top: 40px;
  width: 154px;
  height: 35px;
  background: var(--mainColor);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: var(--pageMarginRight);
  padding-left: 10px;
  color: #fff;
  font-family: 'Open Sans';
  font-size: 16px;
`;

const ProfileImage = styled(TemplateProfileImage)`
  position: absolute;
  top: 23px;
  left: 41px;
`;

type HeaderProps = {
  pageIndex: number;
};

export const Header: React.FC<HeaderProps> = ({ pageIndex }) => {
  const { cv, fileAttachments } = useReadVitaReactiveVariable();
  const intl = useIntl();

  if (!cv) return null;

  const firstName = cv.personalInformation?.firstName;
  const lastName = cv.personalInformation?.lastName;
  const lebenslauf = intl.formatMessage({ id: 'CRATE_VITA_TEMPLATE_TAG' });

  const fontSize = getTemplateHeaderFontSize({
    textLength: Math.max(firstName?.length || 0, lastName?.length || 0),
    resizeAfterIndex: 5,
    max: 40,
    min: 20,
  });

  const image = fileAttachments?.profileImage?.url;

  return (
    <Container>
      {pageIndex === 0 ? (
        <>
          <ProfileImage
            fileAttachments={fileAttachments}
            width="112"
            height="112"
          />
          <Name $hasImage={!!image}>
            <NameField {...fontSize}>{firstName}</NameField>
            <NameField {...fontSize}>{lastName}</NameField>
          </Name>
        </>
      ) : null}
      <Tag>{lebenslauf}</Tag>
    </Container>
  );
};
